import { selectorFamily } from 'recoil';
import { createArrayByKeySelectorFamily, createArrayByUniqueKeyHigherOrderSelectorFamily, createArrayByUniqueKeySelectorFamily, createFieldSelectorFamily, } from '@zurich/common/recoil';
import { insuredObjectsSelector } from '../root';
// TODO: we might have to do this reindexing with insured objects!
/*const sortAndReindex = (insuredObjects: InsuredObjects[], reindex?: boolean) =>
  insuredObjects
    .sort(
      // FIXME: this probably only works for numbers 0-9
      (a, b) =>
        // FIXME: undefined should not be possible
        a.insuredObjectId && b.insuredObjectId
          ? a.insuredObjectId.localeCompare(b.insuredObjectId)
          : 0
    )
    .map((v, i) => {
      if (!reindex) return v;
      // re-index insuredObjectIds for vehicles
      // we only need this in case there are less vehicles than ids,
      // e.g. only one vehicle with id "1"
      return { ...v, insuredObjectId: i + 1 + '' };
    });*/
export const insuredObjectSelectorFamily = createArrayByUniqueKeySelectorFamily(insuredObjectsSelector, 'insuredObjectId', { defaultValue: {} });
export const insuredObjectsByTypeSelectorFamily = createArrayByKeySelectorFamily(insuredObjectsSelector, 'insuredObjectType');
const insuredObjectFieldHelper = createFieldSelectorFamily(insuredObjectSelectorFamily);
export const insuredObjectInsuredObjectIdSelectorFamily = insuredObjectFieldHelper('insuredObjectId', {
    defaultValue: undefined,
});
export const insuredObjectInsuredObjectTypeSelectorFamily = insuredObjectFieldHelper('insuredObjectType', {
    defaultValue: undefined,
});
export const insuredObjectInsuranceSegmentsSelectorFamily = insuredObjectFieldHelper('insuranceSegments', {
    defaultValue: [],
});
// insuredObject[insuredObjectId].insuranceSegments[segmentKey]
export const insuranceObjectInsuranceSegmentSelectorFamily = createArrayByUniqueKeyHigherOrderSelectorFamily(insuredObjectInsuranceSegmentsSelectorFamily, 'segmentKey', {
    defaultValue: {},
});
/**
 * @category Selector
 * @return insured object based on insured object id and insrued object type
 */
export const insuredObjectByInsuredObjectIdAndInsuredObjectTypeSelector = selectorFamily({
    key: '@zurich/contract/insuredObjects/insuredObjectByIndex',
    get: ({ insuredObjectId, insuredObjectType }) => ({ get }) => {
        const allInsuredObjects = get(insuredObjectsByTypeSelectorFamily({ insuredObjectType }));
        return allInsuredObjects.find((iO) => iO.insuredObjectId === insuredObjectId);
    },
});
